// extracted by mini-css-extract-plugin
export var active = "drop-down-list-module--active--OP7sH";
export var arrow = "drop-down-list-module--arrow--OER8M";
export var column = "drop-down-list-module--column--hFpn4";
export var innerWrapper = "drop-down-list-module--inner-wrapper--3XVmP";
export var tab = "drop-down-list-module--tab--n8V7v";
export var tabs = "drop-down-list-module--tabs--bmTdN";
export var text = "drop-down-list-module--text--L9ByY";
export var title = "drop-down-list-module--title--qoy92";
export var titlesContainer = "drop-down-list-module--titles-container--OSgML";